import { render, staticRenderFns } from "./TheStandards.vue?vue&type=template&id=1e0e2365"
import script from "./TheStandards.vue?vue&type=script&lang=js"
export * from "./TheStandards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports